/**
 * Qué configuración de facturación le toca a un complemento de pago.
 *
 * Vive fuera del componente por la misma razón que `avisoTimbres.js`: dentro del render
 * no se puede probar --el primer ciclo corre sin datos-- y el linter prohíbe exportar
 * funciones junto a un componente.
 *
 * El backend exige desde ahora que la configuración permita `complemento`
 * (`FacturacionService.validar_tipo_factura`). Sin esta mitad el contador vería un error
 * en vez de la serie correcta ya elegida: **una regla en el backend pide su mitad aquí**.
 */

/** Las que el SAT y el backend aceptan para un complemento de pago. */
export function paraComplemento(configuraciones) {
  return (configuraciones || []).filter(
    (c) => (c?.tipos_permitidos || []).includes('complemento')
  )
}

/**
 * Cuál preseleccionar, o `null` si hay que preguntar.
 *
 * Antes se preseleccionaba «la única si hay una sola», y con dos --la de facturas y la de
 * complementos-- no se elegía ninguna: el contador terminaba marcando la de facturas, que
 * es la que reconoce. Efecto medido en producción: **ocho contadores** con una serie
 * `PAGO`/`REP` configurada y sin estrenar, mientras sus complementos gastaban folios de la
 * serie de facturas --y un folio de factura que se va a un complemento deja un hueco en un
 * consecutivo que viaja en contratos--.
 *
 * Con varias candidatas no se adivina: elegir la serie de un comprobante fiscal por orden
 * de lista sería inventar una decisión del contador.
 */
export function preseleccionar(configuraciones) {
  const candidatas = paraComplemento(configuraciones)
  if (candidatas.length === 1) return String(candidatas[0].id)
  if (candidatas.length === 0 && configuraciones?.length === 1) {
    // Sin ninguna marcada para complementos, la única que hay es la mejor apuesta; el
    // backend dirá que no si tampoco sirve, y ese error es informativo.
    return String(configuraciones[0].id)
  }
  return null
}
